export default __webpack_public_path__ + "assets/2a12d16bd95c34e3988ee6773b8620e1.png";